//Harshada Bhavsar(4/7/2025)
//AuthController API for Employee Login with email and password, Verify Token API, Logout API
import axios from "../../../axios";
import Cookies from "js-cookie";

export const loginEmployee = async (email, password) => {
	return axios.post("/api/Auth/Employee/Login", { email, password });
};

export const verifyEmployeeOtp = async (verificationCode, authUID) => {
	return axios.post("/api/Auth/VerifyEmployeeAuth", {
		verificationCode,
		authUID,
	});
};

export const verifyToken = async (token) => {
	return axios.post("/api/Auth/Employee/Verify", {
		Token: token,
	});
};

// --Sanket Raut--
//Consultant Login
export const Consultantlogin = async (email, password) => {
	return axios.post("/api/Auth/Consultant/Login", { email, password });
};

//Harshada Bhavsar
export const verifyConsultantOtp = async (verificationCode, authUID) => {
	return axios.post("/api/Auth/VerifyConsultantAuth", {
		verificationCode,
		authUID,
	});
};

// --Shyama Panda--
//Get Employee Name
export const GetEmployeeName = async (Token) => {
	return axios.post("/api/Auth/Employee/Verify", { Token });
};

// --Sanket Raut--
export const LogoutEmp = async (userTokenExpiry) => {
	const token = Cookies.get("employeeToken");

	return axios.post("/api/Auth/Employee/Logout", {
		token,
		userTokenExpiry,
	});
};

// --Harshada Bhavsar (26/12/2025)--
// Consultant Logout
export const LogoutConsultant = async (userTokenExpiry) => {
	const token = Cookies.get("ConsultantToken");

	return axios.post("/api/Auth/Consultant/Logout", {
		token,
		userTokenExpiry,
	});
};

// --Harshada Bhavsar (26/12/2025)--
//Get Consultant Name
export const GetConsultantName = async (Token) => {
	return axios.post("/api/Auth/Consultant/Verify", { Token });
};

export const employeeADLogin = (employeeCode, password) => {
	return axios.post("/api/Auth/EmployeeAD", {
		employeeCode,
		password,
	});
};

export const forgotPasswordEmployee = async (email, employeeCode) => {
  return axios.post("/api/Auth/Employee/ForgotPassword", {
    email,
    employeeCode,
    requestType: 1,
  });
};

export const forgotPasswordConsultant = async (email) => {
  return axios.post("/api/Auth/Employee/ForgotPassword", {
    email,
    employeeCode: "",
    requestType: 2,
  });
};

export const getEmailByUID = async (uid) => {
  return axios.post("/api/Auth/Employee/GetEmailByUID", {
    employeeUID: uid,
  });
};


export const resetPassword = async (requestUID, email, password) => {
  return axios.post("/api/Auth/ResetPassword", {
    requestUID,
    email,
    password,
  });
};

export const InquiryRequest = (name, email, contactNo, message) => {
	return axios.post("/api/Auth/InquiryRequest", {
		name, 
		email, 
		contactNo, 
		message
	});
};